module.exports = __webpack_public_path__ + "static/ft02-d8f2c12dae8914ca29c95a5887375e98.jpg";